import { Link } from "@/lib/nav";

import SectionCard, { sectionCardClass } from "@buildpy/ui/section-card";
import { cn } from "@/lib/utils";
import { publicPortfolioDetailPath } from "@buildpy/core/modules/portfolio/public-view";
import PublicPhoto from "@/modules/portfolio/ui/public-photo";
import type { PublicPortfolioEmbedView } from "@buildpy/core/views/g4b/public-portfolio-embed";

const EmbedNotice = ({ text, testId }: { text: string; testId: string }) => (
  <main className="bg-background p-3 text-foreground">
    <SectionCard as="div" className="p-5 text-center text-sm text-muted-foreground" data-testid={testId} padding="none">
      {text}
    </SectionCard>
  </main>
);

// 홈페이지에 붙이는 시공사례 목록 — 제목·대표 사진만 촘촘히 · 누르면 상세가 새 탭으로 · 없는 주소·공개 끔도 남의 홈페이지에 404 를 띄우지 않고 빈 안내로.
const Page = ({ data }: { data: PublicPortfolioEmbedView }) => {
  if (data.kind === "empty") return <EmbedNotice testId="portfolio-embed-empty" text={data.text} />;
  if (data.kind === "notice") return <EmbedNotice testId="portfolio-embed-notice" text={data.text} />;
  const { slug, cards } = data;

  return (
    <main className="bg-background p-3 text-foreground">
      <ul className="grid grid-cols-2 gap-3 sm:grid-cols-3" data-testid="portfolio-embed-list">
        {cards.map((card) => (
          <li key={card.id}>
            <Link
              className={cn(sectionCardClass({ padding: "none" }), "group flex h-full flex-col overflow-hidden")}
              href={publicPortfolioDetailPath(slug, card.id)}
              rel="noopener"
              target="_blank">
              <PublicPhoto alt={card.title} className="aspect-[4/3] w-full" src={card.cover_src} />
              <span className="line-clamp-2 p-2 text-sm font-medium group-hover:underline">{card.title}</span>
            </Link>
          </li>
        ))}
      </ul>
    </main>
  );
};

export default Page;
